var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.2085C10.5278 10.2085 10.9722 10.0279 11.3333 9.66683C11.6944 9.30572 11.875 8.86127 11.875 8.3335C11.875 7.80572 11.6944 7.36127 11.3333 7.00016C10.9722 6.63905 10.5278 6.4585 10 6.4585C9.47222 6.4585 9.02778 6.63905 8.66667 7.00016C8.30556 7.36127 8.125 7.80572 8.125 8.3335C8.125 8.86127 8.30556 9.30572 8.66667 9.66683C9.02778 10.0279 9.47222 10.2085 10 10.2085ZM10 19.0418C7.54167 17.0002 5.69792 15.146 4.46875 13.4793C3.23958 11.8127 2.625 10.1252 2.625 8.41683C2.625 6.14294 3.36632 4.33141 4.84896 2.98225C6.33174 1.63308 8.04875 0.958496 10 0.958496C11.9513 0.958496 13.6683 1.63308 15.151 2.98225C16.6337 4.33141 17.375 6.14294 17.375 8.41683C17.375 10.1252 16.7604 11.8127 15.5312 13.4793C14.3021 15.146 12.4583 17.0002 10 19.0418Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.6294ae5ef87180bfc7db5e9ad7b64eb1.svg";
export { ForwardRef as ReactComponent };